import { createI18n, PathValue } from "petite-vue-i18n";

import en from "./i18n/english.json";

const i18n = createI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages: { en }, // set locale messages
  legacy: false,
  messageResolver: (obj: unknown, path: string): PathValue | null => {
    const keys = path.split(".");
    const value = keys.reduce((acc, key) => {
      if (acc && typeof acc === "object" && key in acc) {
        return (acc as Record<string, unknown>)[key];
      }
      return null;
    }, obj);
    return value as PathValue;
  },
  fallbacker: (_: string, fallbackLocale: string): string => {
    return fallbackLocale;
  },
});

const loadedLanguages = new Set(["en"]); // our default language that is preloaded
export const languageMap: Record<string, string> = {
  en: "english",
  de: "german",
  ja: "japanese",
  ko: "korean",
  zh: "mandarin",
  es: "spanish",
  fr: "french",
  pt: "portuguese",
  nl: "dutch",
  tr: "turkish",
};

function setI18nLanguage(lang: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  i18n.global.locale.value = lang;
  // This is okay to ts-ignore because we use dynamic loading of languages
  return lang;
}

export async function loadLanguageAsync(fullLang: string): Promise<string> {
  const lang = fullLang.split("-")[0];
  if (i18n.global.locale.value === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  // If the language was already loaded
  if (loadedLanguages.has(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `./i18n/${languageMap[lang]}.json`).then((messages) => {
    i18n.global.setLocaleMessage(lang, messages.default);
    loadedLanguages.add(lang);
    return setI18nLanguage(lang);
  });
}

export default i18n;
